/**
 * Created by 212610877 on 5/23/2017.
 */
import Vue from 'vue';
export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/assets/js/event-bus.js